var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.29 10.2902L12.51 13.0702C12.3436 13.0259 12.1723 13.0024 12 13.0002C10.8955 13.0002 10 13.8956 10 15.0002C10.0023 15.1724 10.0258 15.3437 10.07 15.5102L9.29003 16.2902C9.10072 16.4779 8.99423 16.7335 8.99423 17.0002C8.99423 17.2668 9.10072 17.5224 9.29003 17.7102C9.4778 17.8995 9.73339 18.006 10 18.006C10.2667 18.006 10.5223 17.8995 10.71 17.7102L11.49 16.9302C11.6565 16.9744 11.8278 16.9979 12 17.0002C13.1046 17.0002 14 16.1047 14 15.0002C13.9978 14.8279 13.9743 14.6566 13.93 14.4902L16.71 11.7102C17.1022 11.318 17.1022 10.6823 16.71 10.2902C16.3179 9.89803 15.6822 9.89803 15.29 10.2902ZM12 4.00012C6.47718 4.00012 2.00003 8.47727 2.00003 14.0001C1.99511 15.9807 2.58375 17.9173 3.69003 19.5601C3.99931 20.0185 4.62163 20.1394 5.08003 19.8301C5.53843 19.5208 5.65931 18.8985 5.35003 18.4401C3.11785 15.1023 3.70584 10.6269 6.72447 7.97891C9.7431 5.33094 14.257 5.33094 17.2756 7.97891C20.2942 10.6269 20.8822 15.1023 18.65 18.4401C18.5012 18.6602 18.446 18.9304 18.4966 19.1911C18.5473 19.4519 18.6996 19.6818 18.92 19.8301C19.0856 19.9414 19.2806 20.0006 19.48 20.0001C19.8127 20.0006 20.1238 19.8357 20.31 19.5601C21.4163 17.9173 22.005 15.9807 22 14.0001C22 11.348 20.9465 8.80442 19.0711 6.92905C17.1957 5.05369 14.6522 4.00012 12 4.00012Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.7279a40a.svg";
export { ForwardRef as ReactComponent };